import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SpinnerService } from '~shared/components/buttons/spinner/spinner.service';
import { AuthenticatedUser, Club } from '~core/models';
import { AuthenticationService, NavigationService, StorageService } from '~core/services';

/**
 * Displays the home page with the currently logged in user.
 */
@UntilDestroy()
@Component({
  templateUrl: 'home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy {
  public loading: boolean = true;

  public authenticatedUser: AuthenticatedUser;
  public selectedClub: Club;
  public searchLink: any = './search';
  public clubSettingsLink: any = './settings';
  public clubAttributesLink: any = './attributes';
  public clubUsersLink: any = './users';
  public importsLink: any = './imports';
  public remindersLink: any = './open-reminders';
  public lotteryLink: any = './tixx-select';
  public mergeLink: any = './merge-customer-select';

  public openReminders: number;

  constructor(
    public navigationService: NavigationService,
    public spinnerService: SpinnerService,
    private storage: StorageService,
    private authenticationService: AuthenticationService
  ) {
    this.storage.authenticatedUser.pipe(untilDestroyed(this))
      .subscribe((user: AuthenticatedUser) => this.authenticatedUser = user);
    this.storage.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
    this.navigationService.setCurrentBreadcrumbs(['crm']);
  }

  /**
   * Fetches the currently logged-in user and initializes the animation.
   */
  public ngOnInit(): void {
    this.authenticationService.fetchOpenReminders(this.selectedClub.id).pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        this.openReminders = data.count;
        this.loading = false;
      });
  }

  public ngOnDestroy(): void { }

}
